module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar-guide text-dark"
  }, [(_vm.isModal) ? _c('d-modal', {
    attrs: {
      "show-close": false
    },
    on: {
      "close": function($event) {
        return _vm.setIsModal(false)
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "icon__bg-circle",
    on: {
      "click": function($event) {
        return _vm.setIsModal(false)
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "modal__left"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.calendar_export.create_a_link_on_mobile')))]), _vm._v(" "), _c('ul', {
    staticClass: "export-calendar__cals"
  }, _vm._l((_vm.integrations), function(integration) {
    return _c('li', {
      key: integration.id,
      class: {
        'cal--is-active': _vm.theActiveIntegration === integration.id
      },
      on: {
        "click": function($event) {
          _vm.theActiveIntegration = integration.id
        }
      }
    }, [_vm._v("\n              " + _vm._s(integration.title) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "modal__right"
  }, [_c('h4', {
    staticClass: "marg-2-bottom"
  }, [_vm._v(_vm._s(_vm.$t('vue2.calendar_export.guide_to')) + " " + _vm._s(_vm.integrations[_vm.theActiveIntegration].title))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.theActiveIntegration === 0),
      expression: "theActiveIntegration === 0"
    }],
    staticClass: "embed-container"
  }, [_c('iframe', {
    attrs: {
      "src": "https://www.youtube.com/embed/Vkw-bVsvkq4",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.theActiveIntegration === 1),
      expression: "theActiveIntegration === 1"
    }],
    staticClass: "embed-container"
  }, [_c('iframe', {
    attrs: {
      "src": "https://www.youtube.com/embed/Idpmc8dcFV0",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.isModal) ? _c('div', {
    staticClass: "bg-overlay",
    on: {
      "click": function($event) {
        return _vm.setIsModal(false)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7470078c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExportCalendar/CalendarOnMobileGuides.vue
// module id = 1676
// module chunks = 1